import createDuck from '../../lib/ducks/remoteDuck'
import Order from '../../lib/api/order'

export default createDuck({
  namespace: 'content',
  store: 'orders',
  fetchCallback: Order.handleFetch,
})
